import { render, staticRenderFns } from "./titre-icon-bas-wrapper.vue?vue&type=template&id=60b76f25&"
import script from "./titre-icon-bas-wrapper.vue?vue&type=script&lang=js&"
export * from "./titre-icon-bas-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./titre-icon-bas-wrapper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
